module.exports = __webpack_public_path__ + "static/media/camera-green.f19b4757.svg";